import React from 'react';
import 'twin.macro';
import { StepWrapper } from 'containers/Demarrage/components/StepWrapper';
import { useUpdateDemarrage } from 'containers/Demarrage/queries/useUpdateDemarrage';
import { useDemarrage } from 'containers/Demarrage/queries/useDemarrage';
import { ClassroomsOrgSettings } from 'containers/MesAnneesScolaires/School/Classrooms/ClassroomsOrgSettings';
import { useTranslation } from 'react-i18next';

export function OrganisationMultiNiveaux() {
  const update = useUpdateDemarrage();
  const { t } = useTranslation(['onboarding']);
  const { data: demarrageData } = useDemarrage();
  if (!demarrageData) {
    return null;
  }
  return (
    <StepWrapper
      title={t('onboarding:multiniveau.title')}
      currentStep="organisation-multi-niveaux"
    >
      <div tw="text-neutral-quiet mb-4 text-base">
        {t('onboarding:multiniveau.dontPanic')}
      </div>
      <div tw="mb-12">
        <ClassroomsOrgSettings
          value={demarrageData?.classroomsOrg || 'unified'}
          onChange={v =>
            update({
              classroomsOrg: v,
            })
          }
        />
      </div>
    </StepWrapper>
  );
}
